import api, { cardeal } from './api';

export class SegundaViaBoletoService {
  getBoletosSegundaVia = async (matricula) => {
    const response = await cardeal.get('ObterBoletosSegundaVia', {
      params: {
        matricula,
      },
    });

    return response.data;
  };

  getBoletoCardeal = async (plano, numeroProcesso, numeroCobranca) => {
    try {
      const response = await api.get('ObterBoletoCardeal', {
        params: {
          plano,
          numeroProcesso,
          numeroCobranca,
        },
        responseType: 'arraybuffer',
      });

      return response.data;
    } catch (error) {
      return { erro: 'Ocorreu um erro' };
    }
  };
}
